<template>
<span class="tree-expand">
	<!-- DATA.name+'cor:'+DATA.bindCorpusId -->
	<span style="float:left;">{{DATA.name}}</span>
	<span class="tree-btn" style="float:right;">
		<i class="el-icon-plus" v-if="showCategory(DATA,NODE)" @click.stop="nodeCategoryAdd(STORE,DATA,NODE)">添加子分类</i>
		<i class="el-icon-edit" v-if="DATA.type=='CATEGORY'" @click.stop="nodeCategoryEdit(STORE,DATA,NODE)">修改</i>
		<i class="el-icon-plus" v-if="showDetection(DATA,NODE)" @click.stop="nodeDetectionAdd(STORE,DATA,NODE)">添加检测项</i>
		<i v-if="DATA.type=='DETECTION'" @click.stop="nodeDetectionEdit(STORE,DATA,NODE)">查看/修改</i>
		<i class="el-icon-delete" @click.stop="nodeDel(STORE,DATA,NODE)">删除</i>
	</span>
</span>
</template>

<script>
export default {
  name: 'treeExpand',
  props: ['NODE', 'DATA', 'STORE', 'maxexpandId'],
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    showCategory (data, node) {
      let flag = 0
      if (data.type === 'CATEGORY') {
        // 只有顶级分类、二级分类可以添加子分类
        if (node.level < 3) {
          flag = 1
        }
        // 分类下已添加子集且子集为检测项，则不可添加子分类
        if (typeof (node.childNodes[0]) !== 'undefined' && node.childNodes[0].data.type === 'DETECTION') {
          flag = 0
        }
      }
      if (flag) return true
      return false
    },
    showDetection (data, node) {
      let flag = 0
      if (data.type === 'CATEGORY') {
        if (!node.childNodes.length) {
          flag = 1
        }
        if (typeof (node.childNodes[0]) !== 'undefined' && node.childNodes[0].data.type === 'DETECTION') {
          flag = 1
        }
      }
      if (flag) return true
      return false
    },
    nodeCategoryAdd (s, d, n) { // 新增检测项分类
      this.$emit('nodeCategoryAdd', s, d, n)
    },
    nodeCategoryEdit (s, d, n) { // 修改检测项分类
      this.$emit('nodeCategoryEdit', s, d, n)
    },
    nodeDetectionAdd (s, d, n) { // 新增检测项
      this.$emit('nodeDetectionAdd', s, d, n)
    },
    nodeDetectionEdit (s, d, n) { // 编辑
      this.$emit('nodeDetectionEdit', s, d, n)
    },
    nodeDel (s, d, n) { // 删除
      this.$emit('nodeDel', s, d, n)
    }
  }
}
</script>

<style>
	.tree-expand{
		/* overflow:hidden; */
		/* height: 36px; */
		width:100%;
	}
	.tree-expand .tree-label.tree-new{
		font-weight:600;
	}
	.tree-expand .tree-label{
		font-size:0.9em;
	}
	.tree-expand .tree-label .edit{
		width:80%;
	}
	.tree-expand .tree-btn{
		/* display:none; */
		float:right;
		margin-right:20px;
	}
	.tree-expand .tree-btn i{
		color:#8492a6;
		font-size:0.9em;
		margin-right:8px;
		/* line-height: 36px; */
	}
</style>
